import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "page-wrap ep"
}
const _hoisted_2 = {
  key: 0,
  class: "ep-preview"
}
const _hoisted_3 = { class: "ep-layout" }
const _hoisted_4 = { class: "ep-main" }
const _hoisted_5 = { class: "ep-fmt-where" }
const _hoisted_6 = { class: "ep-paper" }
const _hoisted_7 = { class: "ve-ed-h" }
const _hoisted_8 = { class: "ve-n" }
const _hoisted_9 = { class: "ve-ed-lbl" }
const _hoisted_10 = { class: "ve-ed-tools" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "ve-ed-grid" }
const _hoisted_14 = ["rows", "value"]
const _hoisted_15 = ["rows", "value"]
const _hoisted_16 = { class: "ve-ed-body" }
const _hoisted_17 = { class: "ve-ed-row" }
const _hoisted_18 = {
  key: 0,
  class: "ve-ed-pic"
}
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "grow" }
const _hoisted_21 = ["onUpdate:modelValue"]
const _hoisted_22 = ["onUpdate:modelValue"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "ve-ed-row" }
const _hoisted_25 = { class: "ve-color" }
const _hoisted_26 = ["value"]
const _hoisted_27 = {
  key: 1,
  class: "ep-empty"
}
const _hoisted_28 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_editor_bar = _resolveComponent("editor-bar")!
  const _component_editor_mode_toggle = _resolveComponent("editor-mode-toggle")!
  const _component_playbook_view = _resolveComponent("playbook-view")!
  const _component_tip_tap_toolbar = _resolveComponent("tip-tap-toolbar")!
  const _component_editor_doc_head = _resolveComponent("editor-doc-head")!
  const _component_tip_tap = _resolveComponent("tip-tap")!
  const _component_value_engine_view = _resolveComponent("value-engine-view")!
  const _component_editor_activity = _resolveComponent("editor-activity")!
  const _component_editor_details_drawer = _resolveComponent("editor-details-drawer")!
  const _component_editor_save_dialog = _resolveComponent("editor-save-dialog")!
  const _component_editor_discard_dialog = _resolveComponent("editor-discard-dialog")!
  const _component_confirm_delete = _resolveComponent("confirm-delete")!
  const _component_ai_improve_panel = _resolveComponent("ai-improve-panel")!

  return (_ctx.isLoaded)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_editor_bar, {
          name: _ctx.node.Name,
          version: _ctx.node.Version,
          dirty: _ctx.dirty,
          "type-label": "value engine",
          onCancel: _cache[1] || (_cache[1] = ($event: any) => (_ctx.cancel())),
          onSave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openSave())),
          onHeight: _cache[3] || (_cache[3] = ($event: any) => (_ctx.barHeight = $event))
        }, {
          default: _withCtx(() => [
            _createElementVNode("button", {
              type: "button",
              class: "ai-btn pb-btn",
              title: "Improve with AI",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showAIModal = true))
            }, [...(_cache[37] || (_cache[37] = [
              _createElementVNode("svg", {
                viewBox: "0 0 24 24",
                class: "ep-fill"
              }, [
                _createElementVNode("path", { d: "M13 0L3.5 14H10l-1.5 10L20 9h-6.5L15 0h-2z" })
              ], -1),
              _createElementVNode("span", null, "Improve with AI", -1)
            ]))])
          ]),
          _: 1
        }, 8, ["name", "version", "dirty"]),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.$store.state.routeLoaded ? 'slide-up view' : 'hide')
        }, [
          _createVNode(_component_editor_mode_toggle, {
            preview: _ctx.showPreview,
            "changed-count": _ctx.changedSteps.length,
            "changed-label": "stages",
            onEdit: _cache[4] || (_cache[4] = ($event: any) => (_ctx.closePreview())),
            onPreview: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openPreview()))
          }, null, 8, ["preview", "changed-count"]),
          (_ctx.showPreview)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_playbook_view, {
                  "preview-node": _ctx.previewNode,
                  "hide-bar": true,
                  "changed-steps": _ctx.changedSteps
                }, null, 8, ["preview-node", "changed-steps"])
              ]))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                class: _normalizeClass(["ep-fmt", { live: _ctx.activeEditor }]),
                style: _normalizeStyle({ top: _ctx.barHeight + 'px' })
              }, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.activeEditor ? 'Stage ' + (_ctx.selected + 1) + ' details' : 'Click into a stage\'s details to format them'), 1),
                (_ctx.activeEditor)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "ep-fmt-btns",
                      onMousedown: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.keepEditorFocus && _ctx.keepEditorFocus(...args)))
                    }, [
                      _createVNode(_component_tip_tap_toolbar, {
                        editor: _ctx.activeEditor,
                        "show-align": true
                      }, null, 8, ["editor"])
                    ], 32))
                  : _createCommentVNode("", true)
              ], 6),
              _createElementVNode("article", _hoisted_6, [
                _createVNode(_component_editor_doc_head, {
                  locs: _ctx.locs,
                  deps: _ctx.deps,
                  types: _ctx.types,
                  "owner-names": _ctx.ownerNames,
                  version: _ctx.node.Version,
                  onOpen: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showDetails = true))
                }, null, 8, ["locs", "deps", "types", "owner-names", "version"]),
                _createVNode(_component_value_engine_view, {
                  items: _ctx.items,
                  editable: true,
                  selected: _ctx.selected,
                  "item-key": _ctx.keyOf,
                  "onUpdate:selected": _cache[21] || (_cache[21] = ($event: any) => (_ctx.select($event)))
                }, {
                  add: _withCtx(() => [
                    _createElementVNode("button", {
                      type: "button",
                      class: "ve-add",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.addItem(_ctx.items.length)))
                    }, [...(_cache[38] || (_cache[38] = [
                      _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                        _createElementVNode("path", { d: "M12 5v14M5 12h14" })
                      ], -1),
                      _createElementVNode("span", null, "Add stage", -1)
                    ]))])
                  ]),
                  editor: _withCtx(() => [
                    (_ctx.current)
                      ? (_openBlock(), _createElementBlock("section", {
                          key: 0,
                          class: "ve-ed",
                          style: _normalizeStyle(_ctx.current.color ? { '--ve-color': _ctx.current.color } : {})
                        }, [
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.selected + 1), 1),
                            _createElementVNode("span", _hoisted_9, "Stage " + _toDisplayString(_ctx.selected + 1) + " of " + _toDisplayString(_ctx.items.length), 1),
                            _createElementVNode("span", _hoisted_10, [
                              _createElementVNode("button", {
                                type: "button",
                                "aria-label": "Move stage left",
                                disabled: _ctx.selected == 0,
                                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.moveItem(_ctx.selected, -1)))
                              }, [...(_cache[39] || (_cache[39] = [
                                _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                                  _createElementVNode("path", { d: "M19 12H5M11 18l-6-6 6-6" })
                                ], -1)
                              ]))], 8, _hoisted_11),
                              _createElementVNode("button", {
                                type: "button",
                                "aria-label": "Move stage right",
                                disabled: _ctx.selected == _ctx.items.length - 1,
                                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.moveItem(_ctx.selected, 1)))
                              }, [...(_cache[40] || (_cache[40] = [
                                _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                                  _createElementVNode("path", { d: "M5 12h14M13 18l6-6-6-6" })
                                ], -1)
                              ]))], 8, _hoisted_12),
                              _createElementVNode("button", {
                                type: "button",
                                "aria-label": "Add a stage after this one",
                                title: "Add a stage after this one",
                                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.addItem(_ctx.selected + 1)))
                              }, [...(_cache[41] || (_cache[41] = [
                                _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                                  _createElementVNode("path", { d: "M12 5v14M5 12h14" })
                                ], -1)
                              ]))]),
                              _createElementVNode("button", {
                                type: "button",
                                class: "del",
                                "aria-label": "Delete stage",
                                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.removeItem(_ctx.selected)))
                              }, [...(_cache[42] || (_cache[42] = [
                                _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                                  _createElementVNode("path", { d: "M4 7h16M10 11v6M14 11v6M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2l1-12M9 7V4h6v3" })
                                ], -1)
                              ]))])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", null, [
                              _cache[43] || (_cache[43] = _createElementVNode("label", {
                                class: "ep-lbl",
                                for: "ve-title"
                              }, [
                                _createTextVNode("Title"),
                                _createElementVNode("span", null, "up to 3 lines")
                              ], -1)),
                              _createElementVNode("textarea", {
                                id: "ve-title",
                                ref: "title",
                                class: "ve-in big",
                                rows: _ctx.lineCount(_ctx.titleText),
                                value: _ctx.titleText,
                                placeholder: "e.g. Freight Request Received",
                                onInput: _cache[13] || (_cache[13] = ($event: any) => (_ctx.onLines($event, 'title')))
                              }, null, 40, _hoisted_14)
                            ]),
                            _createElementVNode("div", null, [
                              _cache[44] || (_cache[44] = _createElementVNode("label", {
                                class: "ep-lbl",
                                for: "ve-sub"
                              }, [
                                _createTextVNode("Subtitle"),
                                _createElementVNode("span", null, "up to 3 lines")
                              ], -1)),
                              _createElementVNode("textarea", {
                                id: "ve-sub",
                                class: "ve-in",
                                rows: _ctx.lineCount(_ctx.subText),
                                value: _ctx.subText,
                                placeholder: "e.g. via Dealer Portal",
                                onInput: _cache[14] || (_cache[14] = ($event: any) => (_ctx.onLines($event, 'sub')))
                              }, null, 40, _hoisted_15)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_16, [
                            _cache[45] || (_cache[45] = _createElementVNode("label", { class: "ep-lbl" }, [
                              _createTextVNode("Details"),
                              _createElementVNode("span", null, "shown when someone clicks this stage")
                            ], -1)),
                            (_openBlock(), _createBlock(_component_tip_tap, {
                              key: _ctx.keyOf(_ctx.current),
                              modelValue: _ctx.current.description,
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.current.description) = $event)),
                              "hide-toolbar": true,
                              "show-align": true,
                              onFocus: _cache[16] || (_cache[16] = ($event: any) => (_ctx.activeEditor = $event))
                            }, null, 8, ["modelValue"]))
                          ]),
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("div", null, [
                              _cache[48] || (_cache[48] = _createElementVNode("label", { class: "ep-lbl" }, "Image", -1)),
                              (_ctx.current.imageURL)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                    _createElementVNode("img", {
                                      src: _ctx.current.imageURL,
                                      alt: "Stage image"
                                    }, null, 8, _hoisted_19),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "ep-x",
                                      "aria-label": "Remove image",
                                      onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.current.imageURL = null))
                                    }, [...(_cache[46] || (_cache[46] = [
                                      _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                                        _createElementVNode("path", { d: "M6 6l12 12M18 6L6 18" })
                                      ], -1)
                                    ]))])
                                  ]))
                                : (_openBlock(), _createElementBlock("label", {
                                    key: 1,
                                    class: _normalizeClass(['ep-chip', { busy: _ctx.uploading }])
                                  }, [
                                    _createElementVNode("input", {
                                      type: "file",
                                      accept: "image/*",
                                      hidden: "",
                                      onChange: _cache[18] || (_cache[18] = ($event: any) => (_ctx.onPickImage($event)))
                                    }, null, 32),
                                    _cache[47] || (_cache[47] = _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                                      _createElementVNode("path", { d: "M15 8h.01M12 21H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v6M3 16l5-5c.93-.9 2.07-.9 3 0l4 4M14 14l1-1c.67-.64 1.33-.84 2-.6M16 19h6M19 16v6" })
                                    ], -1)),
                                    _createTextVNode(_toDisplayString(_ctx.uploading ? 'Uploading…' : 'Add image'), 1)
                                  ], 2))
                            ]),
                            _createElementVNode("div", _hoisted_20, [
                              _cache[51] || (_cache[51] = _createElementVNode("label", { class: "ep-lbl" }, [
                                _createTextVNode("Links"),
                                _createElementVNode("span", null, "shown with the details")
                              ], -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.current.linkMenu || []), (link, j) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: j,
                                  class: "ve-lrow"
                                }, [
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": ($event: any) => ((link.label) = $event),
                                    placeholder: "Label, e.g. Dealer Portal"
                                  }, null, 8, _hoisted_21), [
                                    [_vModelText, link.label]
                                  ]),
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": ($event: any) => ((link.link) = $event),
                                    placeholder: "https://…"
                                  }, null, 8, _hoisted_22), [
                                    [_vModelText, link.link]
                                  ]),
                                  _createElementVNode("button", {
                                    type: "button",
                                    "aria-label": "Remove link",
                                    onClick: ($event: any) => (_ctx.removeLink(j))
                                  }, [...(_cache[49] || (_cache[49] = [
                                    _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                                      _createElementVNode("path", { d: "M6 6l12 12M18 6L6 18" })
                                    ], -1)
                                  ]))], 8, _hoisted_23)
                                ]))
                              }), 128)),
                              _createElementVNode("button", {
                                type: "button",
                                class: "ep-chip",
                                onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.addLink()))
                              }, [...(_cache[50] || (_cache[50] = [
                                _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                                  _createElementVNode("path", { d: "M9 15l6-6M11 6l.46-.54a5 5 0 0 1 7.07 7.07L18 13M13 18l-.4.53a5.07 5.07 0 0 1-7.12 0 4.97 4.97 0 0 1 0-7.07L6 11M16 19h6M19 16v6" })
                                ], -1),
                                _createTextVNode("Add link ", -1)
                              ]))])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("div", null, [
                              _cache[53] || (_cache[53] = _createElementVNode("label", {
                                class: "ep-lbl",
                                for: "ve-color"
                              }, "Color", -1)),
                              _createElementVNode("div", _hoisted_25, [
                                _createElementVNode("input", {
                                  id: "ve-color",
                                  type: "color",
                                  value: _ctx.current.color || '#71e2fb',
                                  onInput: _cache[20] || (_cache[20] = ($event: any) => (_ctx.current.color = ($event.target as HTMLInputElement).value))
                                }, null, 40, _hoisted_26),
                                _cache[52] || (_cache[52] = _createElementVNode("span", {
                                  class: "ve-hint",
                                  style: {"margin":"0"}
                                }, "Number and top edge of the card", -1))
                              ])
                            ])
                          ])
                        ], 4))
                      : (_openBlock(), _createElementBlock("p", _hoisted_27, "No stages yet. Add one to get started."))
                  ]),
                  _: 1
                }, 8, ["items", "selected", "item-key"])
              ])
            ]),
            _createElementVNode("aside", {
              class: "ep-side",
              "aria-label": "Outline",
              style: _normalizeStyle({ top: _ctx.barHeight + 'px' })
            }, [
              _cache[54] || (_cache[54] = _createElementVNode("div", { class: "ep-side-h" }, "Outline", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, i) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: _ctx.keyOf(item),
                  type: "button",
                  class: _normalizeClass(['ep-ol', { on: _ctx.selected == i }]),
                  onClick: ($event: any) => (_ctx.select(i))
                }, [
                  _createElementVNode("span", null, _toDisplayString(i + 1), 1),
                  _createTextVNode(_toDisplayString(_ctx.stageTitle(item) || 'Untitled stage'), 1)
                ], 10, _hoisted_28))
              }), 128)),
              _createVNode(_component_editor_activity, {
                comments: _ctx.comments,
                "signed-count": _ctx.signedCount,
                "required-count": _ctx.requiredSigners.length,
                version: _ctx.node.Version
              }, null, 8, ["comments", "signed-count", "required-count", "version"])
            ], 4)
          ], 512), [
            [_vShow, !_ctx.showPreview]
          ])
        ], 2),
        (_ctx.showDetails)
          ? (_openBlock(), _createBlock(_component_editor_details_drawer, {
              key: 0,
              name: _ctx.node.Name,
              "onUpdate:name": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.node.Name) = $event)),
              ownerIds: _ctx.ownerIDs,
              "onUpdate:ownerIds": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.ownerIDs) = $event)),
              locs: _ctx.locs,
              "onUpdate:locs": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.locs) = $event)),
              deps: _ctx.deps,
              "onUpdate:deps": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.deps) = $event)),
              types: _ctx.types,
              "onUpdate:types": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.types) = $event)),
              "type-label": "value engine",
              onClose: _cache[27] || (_cache[27] = ($event: any) => (_ctx.showDetails = false))
            }, null, 8, ["name", "ownerIds", "locs", "deps", "types"]))
          : _createCommentVNode("", true),
        (_ctx.showSave)
          ? (_openBlock(), _createBlock(_component_editor_save_dialog, {
              key: 1,
              status: _ctx.node.NeedsApprovalType,
              "onUpdate:status": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.node.NeedsApprovalType) = $event)),
              version: _ctx.node.Version,
              "required-count": _ctx.requiredSigners.length,
              "signed-count": _ctx.signedCount,
              busy: _ctx.disableButton,
              "note-placeholder": "e.g. Added the dealer portal link to stage 1",
              onCancel: _cache[29] || (_cache[29] = ($event: any) => (_ctx.showSave = false)),
              onSave: _cache[30] || (_cache[30] = ($event: any) => (_ctx.submitCheck($event)))
            }, null, 8, ["status", "version", "required-count", "signed-count", "busy"]))
          : _createCommentVNode("", true),
        (_ctx.showDiscard)
          ? (_openBlock(), _createBlock(_component_editor_discard_dialog, {
              key: 2,
              onKeep: _cache[31] || (_cache[31] = ($event: any) => (_ctx.showDiscard = false)),
              onDiscard: _cache[32] || (_cache[32] = ($event: any) => (_ctx.leave()))
            }))
          : _createCommentVNode("", true),
        (_ctx.showAIConfirm)
          ? (_openBlock(), _createBlock(_component_confirm_delete, {
              key: 3,
              onConfirm: _cache[33] || (_cache[33] = ($event: any) => (_ctx.submit())),
              onCancel: _cache[34] || (_cache[34] = () => { _ctx.showAIConfirm = false; }),
              msg: _ctx.AIConfirmText
            }, null, 8, ["msg"]))
          : _createCommentVNode("", true),
        (_ctx.showAIModal)
          ? (_openBlock(), _createBlock(_component_ai_improve_panel, {
              key: 4,
              "node-type": "timeline",
              slug: _ctx.node.Slug,
              "current-draft": { name: _ctx.node.Name, items: _ctx.timelineJSON.items },
              onClose: _cache[35] || (_cache[35] = ($event: any) => (_ctx.showAIModal = false)),
              onApply: _cache[36] || (_cache[36] = d => { _ctx.onAIDraft(d); _ctx.showAIModal = true }),
              onAccept: _ctx.onAIDraft
            }, null, 8, ["slug", "current-draft", "onAccept"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}